export default {
  methods: {
    userIsGuest () {
      return this.$engine.user.activeAccount === '3'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/userStatusMixin.js